import React from 'react';
import { useOccupancyAndAverageDailyRateData } from './OccupancyAndAverageDailyRateData';
import type { OccupancyAndAverageDailyRate } from '../../../shared/models/kpis.model';

export const OccupancyAndAverageDailyRateDataContext = React.createContext<
  OccupancyAndAverageDailyRate[] | null
>(null);

export const OccupancyAndAverageDailyRateDataProvider = ({
  children,
  monthsCount,
  payload
}: {
  children: React.ReactNode;
  monthsCount: number;
  payload?: {
    query?: {
      unitTypeIds?: number[];
      unitTypeGroupIds?: string[];
    };
  };
}) => {
  const data = useOccupancyAndAverageDailyRateData(monthsCount, payload ?? {});

  return (
    <OccupancyAndAverageDailyRateDataContext.Provider value={data}>
      {children}
    </OccupancyAndAverageDailyRateDataContext.Provider>
  );
};
